import type { AuthClient } from '@church/api-client'
import { createContext, useContext, type ReactNode } from 'react'

/**
 * Makes the better-auth client available to session hooks, mirroring
 * `ApiProvider` for the Eden client. Injected because web and mobile construct
 * it differently (cookies vs. the expo plugin's SecureStore jar).
 */
const AuthClientContext = createContext<AuthClient | null>(null)

export function AuthClientProvider({
  client,
  children,
}: {
  client: AuthClient
  children: ReactNode
}) {
  return <AuthClientContext.Provider value={client}>{children}</AuthClientContext.Provider>
}

export function useAuthClient(): AuthClient {
  const client = useContext(AuthClientContext)
  if (!client) throw new Error('useAuthClient must be used inside an <AuthClientProvider>')
  return client
}
